import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import painting1 from 'assets/img/interiorandexterior.jpg'
import painting2 from 'assets/img/gallery/During Work - 4.jpg'
import painting3 from 'assets/img/pressurewashing.jpg'
import painting4 from 'assets/img/cabinet.jpg'
import painting5 from 'assets/img/gallery/During Work - 3.jpg'
import painting6 from 'assets/img/gallery/Oil Decking 1.jpg'
import painting7 from 'assets/img/gallery/feature wall.jpg'
import painting8 from 'assets/img/waterdamage.jpg'



const cardStyle = {
    maxWidth: "345px",
};

const containerStyle = {
    marginBottom: "1rem"
};


export default function ImgMediaCard() {

  return (
    <>

    <GridContainer justify="center">

      <GridItem xs={12} sm={6} md={4} style={containerStyle}>
        <Card style={cardStyle}>
          <CardActionArea>
            <CardMedia
              component="img"
              alt="Contemplative Reptile"
              height="200"
              image={painting1}
              title="Interior and Exterior"
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Interior & Exterior Painting
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button size="small" color="primary">
              Learn More
            </Button>
          </CardActions>
        </Card>
      </GridItem>

      <GridItem xs={12} sm={6} md={4} style={containerStyle}>
        <Card style={cardStyle}>
          <CardActionArea>
            <CardMedia
              component="img"
              alt="Roof cleaning and Painting"
              height="200"
              image={painting2}
              title="Roof cleaning and Painting"
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Roof cleaning and Painting
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button size="small" color="primary">
              Learn More
            </Button>
          </CardActions>
        </Card>
      </GridItem>

      <GridItem xs={12} sm={6} md={4} style={containerStyle}>
        <Card style={cardStyle}>
          <CardActionArea>
            <CardMedia
              component="img"
              alt="Pressure Washing"
              height="200"
              image={painting3}
              title="Pressure Washing"
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Pressure Washing
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button size="small" color="primary">
              Learn More
            </Button>
          </CardActions>
        </Card>
      </GridItem>

      <GridItem xs={12} sm={6} md={4} style={containerStyle}>
        <Card style={cardStyle}>
          <CardActionArea>
            <CardMedia
              component="img"
              alt="Cabinet Painting"
              height="200"
              image={painting4}
              title="Cabinet Painting"
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Cabinet Painting
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button size="small" color="primary">
              Learn More
            </Button>
          </CardActions>
        </Card>
      </GridItem>

      <GridItem xs={12} sm={6} md={4} style={containerStyle}>
        <Card style={cardStyle}>
          <CardActionArea>
            <CardMedia
              component="img"
              alt="Fence Painting"
              height="200"
              image={painting5}
              title="Fence Painting"
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Fence Painting
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button size="small" color="primary">
              Learn More
            </Button>
          </CardActions>
        </Card>
      </GridItem>

      <GridItem xs={12} sm={6} md={4} style={containerStyle}>
        <Card style={cardStyle}>
          <CardActionArea>
            <CardMedia
              component="img"
              alt="Oil Decking"
              height="200"
              image={painting6}
              title="Oil Decking"
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Oil Decking
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button size="small" color="primary">
              Learn More
            </Button>
          </CardActions>
        </Card>
      </GridItem>

      <GridItem xs={12} sm={6} md={4} style={containerStyle}>
        <Card style={cardStyle}>
          <CardActionArea>
            <CardMedia
              component="img"
              alt="Feature Wall Painting"
              height="200"
              image={painting7}
              title="Feature Wall Painting"
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Feature Wall Painting
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button size="small" color="primary">
              Learn More
            </Button>
          </CardActions>
        </Card>
      </GridItem>

      <GridItem xs={12} sm={6} md={4} style={containerStyle}>
        <Card style={cardStyle}>
          <CardActionArea>
            <CardMedia
              component="img"
              alt="Specialist in water damage work"
              height="200"
              image={painting8}
              title="Specialist in water damage work"
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Specialist in water damage work
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button size="small" color="primary">
              Learn More
            </Button>
          </CardActions>
        </Card>
      </GridItem>


    </GridContainer>

    </>
  );
}
